module.exports = __webpack_public_path__ + "assets/mobile_back_blue-cde8be.svg";